<script lang="ts">
	import RevenueCalendar from "@hitit/hub/src/v7/components/revenue/RevenueCalendar.svelte";
	import OrderHistory from "../components/revenue/OrderHistory.svelte";
	import { endOfMonth, startOfMonth } from "date-fns";
	import { onDestroy } from "svelte";
	import { popup } from "../store";

	export let date = new Date();
	export let storeId = "";

	$: range = {
		start: startOfMonth(date),
		end: endOfMonth(date),
	};

	onDestroy(() => {
		$popup = undefined;
	});

</script>

<div class="container">
	<RevenueCalendar storeId={storeId} bind:date />
	<OrderHistory storeId={storeId} range={range} />
</div>

<style lang="scss">
	.container {
		display: flex;
		flex-direction: column;
		gap: 30px;
	}

</style>
